/**
 * Groups consecutive marketing items by their namespace property.
 *
 * This enables AI feature grouping where consecutive features with
 * namespace: 'ai' are grouped together for special rendering.
 *
 * @param marketingItems - Array of marketing items with optional namespace
 * @returns Array of groups, each containing consecutive items with the same namespace
 *
 * @example
 * Input: [
 *   { text: "Feature 1" },                    // undefined namespace
 *   { text: "AI Feature 1", namespace: "ai" }, // ai namespace
 *   { text: "AI Feature 2", namespace: "ai" }, // ai namespace (consecutive)
 *   { text: "Feature 2" }                     // undefined namespace
 * ]
 *
 * Output: [
 *   { namespace: undefined, items: [{ text: "Feature 1" }], startIndex: 0 },
 *   { namespace: "ai", items: [{ text: "AI Feature 1" }, { text: "AI Feature 2" }], startIndex: 1 },
 *   { namespace: undefined, items: [{ text: "Feature 2" }], startIndex: 3 }
 * ]
 */
export const groupFeaturesByNamespace = (marketingItems) => {
    const groups = [];
    let currentGroup = null;
    marketingItems.forEach((item, index) => {
        const namespace = item.namespace;
        // Start new group if namespace changes or this is the first item
        if (!currentGroup || currentGroup.namespace !== namespace) {
            currentGroup = {
                namespace,
                items: [],
                startIndex: index,
            };
            groups.push(currentGroup);
        }
        // Add item to current group
        currentGroup.items.push(item);
    });
    return groups;
};
//# sourceMappingURL=groupFeaturesByNamespace.js.map